import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from "react";
export default function ObfuscatedMailto(_ref) {
  var base64Email = _ref.base64Email,
      _ref$loadTime = _ref.loadTime,
      loadTime = _ref$loadTime === void 0 ? 5000 : _ref$loadTime,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1000 : _ref$step,
      _ref$loadingMessage = _ref.loadingMessage,
      loadingMessage = _ref$loadingMessage === void 0 ? "Loading " : _ref$loadingMessage;

  var _useState = useState(loadingMessage),
      _useState2 = _slicedToArray(_useState, 2),
      myEmail = _useState2[0],
      setMyEmail = _useState2[1];

  useEffect(function () {
    var steps = [];

    for (var i = step; i < loadTime; i += step) {
      steps.push(i);
    }

    var ids = steps.map(function (time) {
      setTimeout(function () {
        return setMyEmail(function (x) {
          return x + ".";
        });
      }, time);
    });
    setTimeout(function () {
      ids.map(clearTimeout);
      setMyEmail(atob(base64Email));
    }, loadTime + step);
  }, []);
  return React.createElement("a", {
    href: "mailto:".concat(myEmail)
  }, myEmail); // return <a href={`mailto:${myEmail}`}>{myEmail}</a>;
}